module.exports = __webpack_public_path__ + "img/FP.FS.0df1cb51.png";